import Icon from 'components/Shared/Icon';
import Markdown from 'components/Shared/Markdown';
import { rm } from 'utils';
import styles from './styles.scss';

export const CreditWarning = () => {
  return (
    <div className={styles.creditWarning}>
      <Icon icon="icon-warning" className={styles.icon} />
      <div className={styles.text}>
        <strong>{rm('checkout_payment_credit_warning_title')}</strong>
        <Markdown tag="p" content={rm('checkout_payment_credit_warning_text')} />
      </div>
    </div>
  );
};
